import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardSelectTemplateUX = (props: any) => {
    return(
      <div
        id="CardSelectTemplateUX-div-0"
        style={{height: "100%"}}>
        <div
          id="CardSelectTemplateUX-div-8"
          style={{margin: "15px 0 0 0"}}>
          {props.languageUX === "en" ? "Table is entered based on the clinic table template." : "ลงตารางโดยอ้างอิงจากเทมเพลทตารางคลินิก"}
        </div>
        <Table
          data={props.scheduleTemplates}
          getTrProps={props.templateRowProps}
          headers="วันที่เริ่ม,วันที่สิ้นสุด"
          id="CardSelectTemplateUX-Table-9"
          keys="start,end"
          minRows="2"
          showPagination={false}
          style={{height: "120px"}}>
        </Table>
        <div
          id="CardSelectTemplateUX-div-16"
          style={{flexDirection: "column", marginTop: "10px", display: "flex",justifyContent: "space-between"}}>
          
          <div
            id="CardSelectTemplateUX-div-24"
            style={{display: "flex", marginBottom: "0.25rem"}}>
            
            <div
              id="CardSelectTemplateUX-div-17"
              style={{marginRight: "10px", flex: 1}}>
              {props.languageUX === "en" ? "since" : "ตั้งแต่"}
            </div>
            <div
              id="CardSelectTemplateUX-div-27"
              style={{flex: 5}}>
              
              <DateTextBox
                disabled={props.readonly}
                id="CardSelectTemplateUX-DateTextBox-20"
                onChange={props.changeDate("startDateTime")}
                style={{flex: 3}}
                value={props.startDateTime}>
              </DateTextBox>
            </div>
          </div>
          <div
            id="CardSelectTemplateUX-div-25"
            style={{display: "flex"}}>
            
            <div
              id="CardSelectTemplateUX-div-19"
              style={{marginRight: "10px", flex: 1}}>
              {props.languageUX === "en" ? "to" : "ถึง"}
            </div>
            <div
              id="CardSelectTemplateUX-div-28"
              style={{flex: 5}}>
              
              <DateTextBox
                disabled={props.readonly}
                id="CardSelectTemplateUX-DateTextBox-21"
                onChange={props.changeDate("endDateTime")}
                style={{flex: 3}}
                value={props.endDateTime}>
              </DateTextBox>
            </div>
          </div>
        </div>
        <div
          id="CardSelectTemplateUX-div-11"
          style={{margin: "15px 0 0 0"}}>
          {props.languageUX === "en" ? "Select date and time" : "เลือกวันเวลา"}
        </div>
        <Table
          data={props.templateItems}
          getTrProps={props.templateItemProps}
          headers="เลือก,วัน,รายละเอียด,"
          id="CardSelectTemplateUX-Table-10"
          keys="active,weekday,detail,edit"
          minRows="6"
          showPagination={false}
          style={{height: "35vh"}}
          widths="^50,^105,^110,^80">
        </Table>
        <div
          id="CardSelectTemplateUX-div-12"
          style={{display: "flex", justifyContent: "flex-end", margin: "15px 0 0 0", gap: "20px"}}>
          
          <div
            id="CardSelectTemplateUX-div-29">
            {props.buttonCreate}
          </div>
          <div
            id="CardSelectTemplateUX-div-30">
            {props.buttonClear}
          </div>
        </div>
      </div>
    )
}


export default CardSelectTemplateUX

export const screenPropsDefault = {"providerSelector":"[Component for selecting provider]","selectedProvider":{}}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ลงตารางโดยอ้างอิงจากเทมเพลทตารางคลินิก",
          "valueEN": "Table is entered based on the clinic table template."
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"15px 0 0 0\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 9,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.scheduleTemplates"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.templateRowProps"
        },
        "headers": {
          "type": "value",
          "value": "วันที่เริ่ม,วันที่สิ้นสุด"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-Table-9"
        },
        "keys": {
          "type": "value",
          "value": "start,end"
        },
        "minRows": {
          "type": "value",
          "value": "2"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"120px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 10,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.templateItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.templateItemProps"
        },
        "headers": {
          "type": "value",
          "value": "เลือก,วัน,รายละเอียด,"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-Table-10"
        },
        "keys": {
          "type": "value",
          "value": "active,weekday,detail,edit"
        },
        "minRows": {
          "type": "value",
          "value": "6"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"35vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "^50,^105,^110,^80"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลา",
          "valueEN": "Select date and time"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"15px 0 0 0\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", margin: \"15px 0 0 0\", gap: \"20px\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{flexDirection: \"column\", marginTop: \"10px\", display: \"flex\",justifyContent: \"space-between\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "ตั้งแต่",
          "valueEN": "since"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", flex: 1}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", flex: 1}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 20,
      "name": "DateTextBox",
      "parent": 27,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readonly"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-DateTextBox-20"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDate(\"startDateTime\")"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3}"
        },
        "value": {
          "type": "code",
          "value": "props.startDateTime"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 21,
      "name": "DateTextBox",
      "parent": 28,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readonly"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-DateTextBox-21"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDate(\"endDateTime\")"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3}"
        },
        "value": {
          "type": "code",
          "value": "props.endDateTime"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginBottom: \"0.25rem\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{flex: 5}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{flex: 5}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCreate"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonClear"
        },
        "id": {
          "type": "value",
          "value": "CardSelectTemplateUX-div-30"
        }
      },
      "seq": 30,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSelectTemplateUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "providerSelector": "[Component for selecting provider]",
    "selectedProvider": {
    }
  },
  "width": 25
}

*********************************************************************************** */
